import {
  FETCH_ALL_SCHOOLS,
  // GET_SCHOOL,
  // CREATE_SCHOOL,
  // UPDATE_SCHOOL,
  // DELETE_SCHOOL,
  ROOT_URL
} from "../../constants";
import axios from 'axios';

export const fetchSchools = (district, history) => {
  const url = `${ROOT_URL}/schools?districtId=${district.id}`;
  return (dispatch) => {
    axios
      .get(url, {withCredentials:true})
      .then((data) => {
        console.log(data);
        dispatch({
          type: FETCH_ALL_SCHOOLS,
          schools: data.data
        })
      })
      .catch(err => console.error(err))
  }
};